<template>
<div >
    <v-toolbar flat color="white" class= "pt-3">
        <v-btn id="switchingCentreAddButtonId" color="primary" dark class="mb-2" @click="newDialog=true;cancelFields()" round >Add Switching Centre</v-btn>
        <!-- <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="locationnodes"
    worksheet="export"
    :name="'Nodes_'+new Date().getTime() / 1000+'.xls'">
    Export to Excel
</download-excel></v-btn> -->
        <v-spacer></v-spacer>
        <v-text-field
        id="searchId"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    
    <v-dialog persistent v-model="newDialog" max-width="500px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD SWITCHING CENTRE</h1>
        <v-spacer></v-spacer>
          <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    id="switchingCentreAddNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Switching Centre Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm6 md4>
                  <v-switch v-model="editedItem.isActive"  label="isActive"></v-switch>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center align-center>
            <v-btn v-if="editedItem.name" color="primary" class="white--text" round @click="saveNew">Save</v-btn>
            <v-btn v-else disabled round>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

          <!-- EDIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
          <!-- EDIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT SWITCHING CENTRE</h1>
         <v-spacer></v-spacer>
          <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    id="switchingCentreEditNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Switching Centre Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>

            <v-layout justify-center align-center>
            <v-btn v-if="editedItem.name" color="primary" class="white--text" round @click="save">Save</v-btn>
            <v-btn v-else disabled round>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
     
<v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="switchingcentres"
      item-key="id"
      :key="name"
      :rows-per-page-items="[10, 25, 50, 100]"
      align-center
      next-icon
      prev-icon
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
            <v-icon id="switchingCentreEditButtonId" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon id="switchingCentreDeleteButtonId" small @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td  class="text-xs-center">{{props.item.name}}</td>
          <td  class="text-xs-center" v-if="props.item.isActive===true"><v-chip small :class="`Active white--text caption my-2`">Active</v-chip></td>
          <td class="text-xs-center" v-else><v-chip small :class="`Inactive white--text caption my-2`">InActive</v-chip></td>

      </template>
      <!-- Custom Row count and Paging text -->

      <!-- Start Here ///////////////////////////////////////////////////////////////////////// -->
      <!-- <template
        v-slot:pageText="props"
      >Records {{ recordCalculator(props.pageStart) }} - {{ recordCalculator(props.pageStop )}} of {{ totalitems }}  {{pageCount(props.itemsLength, props.pageStart, props.pageStop )}}
      </template> -->
      <!-- Expand Rows  -->
      
      <!-- No data Dispalay -->
    </v-data-table>
    <!-- <div class="text-xs-center pt-2">
      <v-btn flat  v-show="page>1" @click="pager(-1)"><v-icon>keyboard_arrow_left </v-icon> Previous</v-btn>
      <v-btn flat disabled >{{page}}</v-btn>
      <v-btn flat v-show="page<pages" @click="pager(1)">Next<v-icon>keyboard_arrow_right </v-icon> </v-btn>
    </div> -->

</div>
</template>

<script>
import Api from "@/services/Api";
import format from "date-fns/format";
export default {
  
    props:['switchingcentres','totalitems','isloading'],
    data() {
        return {
            name: "",
            switchingCentresLength: null,
            showDetails: true,
            loading: false, 
            expand: false,
            backButton: false,
            nextButton: true,
            search: "",
            pages: "",
            totalItems: "",
            page: '',
            limit: '',
            countPerPage: [],
            rowsPerPage: 10,
            dialog: false,
            newDialog: false,
            switchingCentres: [],
            switchingCentresLength: [],
            editedIndex: -1,
            editedItem: {
      name: "",
      isActive: true,
      isDeleted: false
    },
    defaultItem: {
      name: "",
      isActive: true,
      isDeleted: false
    },
    headers: [
      {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
      
    ]
    }},
    
    watch: {
    dialog(val) {
      val || this.close();
    },
    },
    computed: {
        formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    },
    pages() {
      
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
      this.pages=Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
    },
    methods: {
      recordCalculator(value){
        return(value+(Math.ceil(this.pagination.rowsPerPage*(this.page-1))))
      },
      pager(value){
        this.page=parseInt(this.page)+(parseInt(value))
        this.pagination.page=this.page
      },
      pageCount(totalItems, start, end){
        if(typeof this.page ==='undefined'){
          this.page=1
        }
        
        this.pages= Math.ceil(this.totalitems/this.pagination.rowsPerPage)
        
        
        if(((start-end)===0)&&totalItems >1){
          this.limit=this.pagination.rowsPerPage
        } else {
          this.limit= this.pagination.rowsPerPage
          this.rowsPerPage=this.limit
        }
      },
    editItem(item) {
      this.editedIndex = this.switchingCentres.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    cancelFields(){
      this.editedItem.name=""
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/switchingcentres/" + this.editedItem.id, {
          isActive: false,
          isDeleted: true
        }).then(response=>
        {this.$emit('switchingCentreSaved')
        })
        
        },

    close() {
      this.dialog = false;
      this.newDialog=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },

    save() {
      let proceed = true
      if(this.editedItem.name == "")
      {proceed = false
      confirm("Please enter a name")
      }
      if(proceed == true){
        Api().put("/switchingcentres/" + this.editedItem.id, {
          name: this.editedItem.name,
          isActive: this.editedItem.isActive,
          isDeleted: !this.editedItem.isActive
        }).then(response=>{
        this.$emit('switchingCentreSaved')
        this.switchingCentres.push(this.editedItem);
        this.close();
        })
      }
      },
      saveNew() {
      let proceed = true
      if(this.editedItem.name == "")
      {proceed = false
      confirm("Please enter a name")
      }
      if(proceed == true){
        Api().post("/switchingcentres", {
          name: this.editedItem.name,
          isActive: this.editedItem.isActive,
          isDeleted: false
        }).then(response=>{
        this.$emit('switchingCentreSaved')
        this.close();
        this.$emit('switchingCentreAdded');
        })
      }
      }
    }
        }
</script>
